/**
 * Make sure the visible account inputs are required
 */
export function handleAccountRequired(): void {
    const accountSelection = document.querySelector(".fundraiser-form__radio[name='account']:checked") as HTMLInputElement | null;

    // The user might already be logged in, so this section doesn't show
    if (!accountSelection) {
        return;
    }

    const accountValue = accountSelection.value;
    const accountFields = document.querySelector(".fundraiser-form__fieldset--account-fields");
    const allInputs = accountFields!.querySelectorAll<HTMLInputElement>("input");

    for (const input of allInputs) {
        input.required = false;
    }

    setAccountRequired(accountValue);
}

/**
 * Sets the required fields
 */
function setAccountRequired(accountValue: string) {
    const createForm = document.querySelector(`.fundraiser-form__act--${accountValue}`);
    const inputs = createForm!.querySelectorAll<HTMLInputElement>("input");

    for (const input of inputs) {
        input.required = true;
    }
}
